/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  slate_10: '#ebf3f7',
  slate_20: '#d3e4ed',
  slate_30: '#b1cfde',
  slate_40: '#8fb6c9',
  slate_50: '#709cb3',
  slate_60: '#598296',
  slate_70: '#47697a',
  slate_80: '#3a5663',
  slate_90: '#2e444f',
  slate_100: '#253740',

  a11y_text_light: [70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/slate.js